// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  width: 100%;
  padding: 22px 0px;
  background-color: #fff;
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
}
header.header-hidden {
  transform: translateY(-100%);
}
header.header-visible {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 1200px) and (max-width: 1365px) {
  header .container {
    padding: 0 20px;
  }
}
header .logo {
  order: 1;
}
header .logo img {
  max-height: 48px;
  width: auto;
}
header .mobile-menu-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}
header .mobile-menu-toggle img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
header .mobile-menu-toggle .close-icon {
  display: none;
}
header .mobile-menu-toggle.active .menu-icon {
  display: none;
}
header .mobile-menu-toggle.active .close-icon {
  display: block;
}
header nav {
  order: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}
header nav ul {
  display: flex;
  list-style: none;
  gap: 40px;
  margin: 0;
  padding: 0;
}
header nav li {
  position: relative;
}
header nav a {
  text-decoration: none;
  color: #004481;
  font-weight: 500;
  padding: 10px 0;
  transition: color 0.3s ease;
  position: relative;
  font-size: 16px;
}
header nav a:hover {
  color: #000;
}
header nav a.active {
  color: #004481;
  border-bottom: 2px solid #004481;
}
header .header-icons {
  order: 3;
  display: flex;
  align-items: center;
  gap: 16px;
}
header .header-icons a {
  display: block;
  text-decoration: none;
  display: none !important;
}
header .header-icons a img {
  width: 18px;
  height: 19px;
  object-fit: contain;
  vertical-align: middle;
}
header .header-icons .search-btn {
  display: none !important;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}
header .header-icons .search-btn img {
  width: 18px;
  height: 19px;
  object-fit: contain;
  vertical-align: middle;
}
header .header-icons .lang-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-decoration: none;
  position: relative;
  cursor: pointer;
}
header .header-icons .lang-selector span {
  font-weight: 400;
  font-size: 15px;
  color: #004481;
  line-height: 1;
}
header .header-icons .lang-selector .dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  min-width: 80px;
  margin-top: 10px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
header .header-icons .lang-selector .dropdown ul {
  list-style: none;
  padding: 8px 0;
  margin: 0;
}
header .header-icons .lang-selector .dropdown li {
  padding: 0;
}
header .header-icons .lang-selector .dropdown a {
  padding: 8px 16px;
  display: block;
  color: #004481;
  font-weight: 200;
  font-size: 16px;
}
header .header-icons .lang-selector .dropdown a:hover {
  background: rgba(0, 68, 129, 0.05);
}
header .header-icons .lang-selector:hover .dropdown {
  opacity: 1;
  visibility: visible;
}
@media (max-width: 1200px) {
  header {
    padding: 13px 20px;
  }
  header .container {
    padding: 0;
  }
  header .logo img {
    max-height: 56px;
    height: 56px;
    width: auto;
  }
  header .header-icons {
    order: 2;
    margin-left: auto;
    margin-right: 20px;
    display: flex;
    align-items: center;
    gap: 30px;
    display: none !important;
  }
  header .header-icons a img {
    width: 24px;
    height: 24px;
  }
  header .header-icons .lang-selector {
    display: none;
  }
  header .mobile-menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    order: 3;
  }
  header .mobile-menu-toggle img {
    width: 28px;
    height: 28px;
  }
  header nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh - 80px);
    margin-top: 80px;
    background: #fff;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 40px;
    padding-bottom: 50px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 8;
    overflow-y: auto;
  }
  header nav.active {
    transform: translateX(0);
  }
  header nav ul {
    flex-direction: column;
    gap: 56px;
    text-align: left;
    align-items: flex-start;
    width: 100%;
    padding: 0 20px;
  }
  header nav a {
    font-size: 24px;
    font-weight: 600;
  }
  header nav a.active {
    border-bottom: none;
    padding: 10px 0;
  }
  header body.menu-open {
    overflow: hidden;
  }
}

.search-overlay {
  position: fixed;
  top: 90px;
  left: 0;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  padding: 15px 0;
  z-index: 9;
  transform: translateY(-100%);
  z-index: 99999999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
}
.search-overlay.active {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}
.search-overlay .container {
  display: flex;
  align-items: center;
}
.search-overlay .search-form {
  width: 100%;
  position: relative;
}
.search-overlay .search-form input {
  width: 100%;
  padding: 10px 32px;
  border: none;
  font-size: 16px;
  color: #333;
  background: transparent;
}
@media (max-width: 1200px) {
  .search-overlay .search-form input {
    padding: 10px 0px;
  }
}
.search-overlay .search-form input:focus {
  outline: none;
}
.search-overlay .search-form input::placeholder {
  color: #999;
}
.search-overlay .close-search {
  margin-right: 32px;
  background: none;
  border: none;
  cursor: pointer;
}
@media (max-width: 1200px) {
  .search-overlay .close-search {
    margin-right: 0px;
  }
}
.search-overlay .close-search img {
  width: 19px;
  height: 19px;
  object-fit: contain;
  transition: transform 0.3s ease;
}
.search-overlay .close-search img:hover {
  transform: rotate(90deg);
}

@media (max-width: 1200px) {
  .search-overlay {
    top: 75px;
  }
}
body.menu-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
body.menu-open header .header-icons > a:first-child {
  display: none;
}

@media (max-width: 1199px) {
  nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh - 80px);
    margin-top: 80px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 40px;
    padding-bottom: 50px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 8;
    overflow-y: auto;
  }
  nav.active {
    transform: translateX(0);
  }
  nav ul {
    flex-direction: column;
    gap: 56px;
    text-align: left;
    align-items: flex-start;
    width: 100%;
    padding: 0 20px;
  }
  nav a {
    font-size: 24px;
    font-weight: 600;
  }
  nav a.active {
    border-bottom: none;
    padding: 10px 0;
  }
  nav .mobile-lang-accordion {
    margin-top: auto;
    width: 100%;
    padding: 0 20px;
    display: none !important;
  }
  nav .mobile-lang-accordion .lang-accordion-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 15px 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }
  nav .mobile-lang-accordion .lang-accordion-toggle .lang-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  nav .mobile-lang-accordion .lang-accordion-toggle .lang-info img {
    width: 18px;
    height: 18px;
  }
  nav .mobile-lang-accordion .lang-accordion-toggle .lang-info span {
    font-size: 16px;
    font-weight: 600;
    color: #004481;
  }
  nav .mobile-lang-accordion .lang-accordion-toggle .toggle-arrow {
    width: 16px;
    height: 16px;
    transition: transform 0.3s ease;
    transform: rotate(0deg);
  }
  nav .mobile-lang-accordion .lang-accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
  }
  nav .mobile-lang-accordion .lang-accordion-content ul {
    padding: 10px 0 10px 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }
  nav .mobile-lang-accordion .lang-accordion-content ul li {
    width: 100%;
  }
  nav .mobile-lang-accordion .lang-accordion-content ul li a {
    display: block;
    padding: 10px 0 0 0px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    text-decoration: none;
    transition: color 0.2s ease;
  }
  nav .mobile-lang-accordion .lang-accordion-content ul li a:hover {
    color: #004481;
  }
  nav .mobile-lang-accordion.active .lang-accordion-toggle .toggle-arrow {
    transform: rotate(180deg);
  }
  nav .mobile-lang-accordion.active .lang-accordion-content {
    max-height: 200px;
  }
}
@media screen and (min-width: 1200px) {
  .mobile-lang-accordion {
    display: none;
  }
}
/* ================================== */
/* Smart Sticky Header Styles - START */
/* ================================== */
header {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  transform: translateY(0);
  box-shadow: none;
}
header.header-hidden {
  transform: translateY(-100%);
  box-shadow: none;
}
header.header-visible {
  transform: translateY(0);
}

/* ================================ */
/* Smart Sticky Header Styles - END */
/* ================================ */
/* =========================================== */
/* Body Padding for Fixed Header - START       */
/* Bu kod style.scss'in sonuna da eklenebilir */
/* =========================================== */
body {
  padding-top: 96px;
}
@media (max-width: 1199px) {
  body {
    padding-top: 86px !important;
  }
}

/* ========================================= */
/* Body Padding for Fixed Header - END         */
/* ========================================= */`, "",{"version":3,"sources":["webpack://./src/components/header/Header.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,6DAAA;EACA,wBAAA;EACA,oDAAA;AACJ;AACI;EACI,4BAAA;AACR;AAGI;EACI,wBAAA;EACA,yCAAA;AADR;AAII;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAIQ;EALJ;IAMQ,eAAA;EADV;AACF;AAII;EACI,QAAA;AAFR;AAGQ;EACI,gBAAA;EACA,WAAA;AADZ;AAKI;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;AAHR;AAKQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,aAAA;AAJZ;AAQY;EACI,aAAA;AANhB;AASY;EACI,cAAA;AAPhB;AAYI;EACI,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAVR;AAYQ;EACI,aAAA;EACA,gBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAVZ;AAaQ;EACI,kBAAA;AAXZ;AAcQ;EACI,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AAZZ;AAcY;EACI,WAAA;AAZhB;AAeY;EACI,cAAA;EACA,gCAAA;AAbhB;AAkBI;EACI,QAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAhBR;AAmBQ;EACI,cAAA;EACA,qBAAA;EACA,wBAAA;AAjBZ;AAoBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAlBhB;AAsBQ;EACI,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AApBZ;AAsBY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AApBhB;AAwBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AAtBZ;AAwBY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAvBhB;AAyBgB;EACI,gBAAA;EACA,cAAA;EACA,SAAA;AAvBpB;AA0BgB;EACI,UAAA;AAxBpB;AA2BgB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAzBpB;AA2BoB;EACI,kCAAA;AAzBxB;AA8BY;EACI,UAAA;EACA,mBAAA;AA5BhB;AAiCI;EA5MJ;IA6MQ,kBAAA;EA9BN;EAgCM;IACI,UAAA;EA9BV;EAkCU;IACI,gBAAA;IACA,YAAA;IACA,WAAA;EAhCd;EAoCM;IACI,QAAA;IACA,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;IACA,wBAAA;EAlCV;EAoCU;IACI,WAAA;IACA,YAAA;EAlCd;EAqCU;IACI,aAAA;EAnCd;EAuCM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,QAAA;EArCV;EAuCU;IACI,WAAA;IACA,YAAA;EArCd;EAyCM;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;IACA,sBAAA;IACA,2BAAA;IACA,iBAAA;IACA,oBAAA;IACA,4BAAA;IACA,+BAAA;IACA,UAAA;IACA,gBAAA;EAvCV;EAyCU;IACI,wBAAA;EAvCd;EA0CU;IACI,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EAxCd;EA2CU;IACI,eAAA;IACA,gBAAA;EAzCd;EA2Cc;IACI,mBAAA;IACA,eAAA;EAzClB;EA8CM;IACI,gBAAA;EA5CV;AACF;;AAgDA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,yCAAA;EACA,eAAA;EACA,UAAA;EACA,4BAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AA7CJ;AA+CI;EACI,wBAAA;EACA,UAAA;EACA,mBAAA;AA7CR;AAgDI;EACI,aAAA;EACA,mBAAA;AA9CR;AAiDI;EACI,WAAA;EACA,kBAAA;AA/CR;AAiDQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AA/CZ;AAiDY;EARJ;IASQ,iBAAA;EA9Cd;AACF;AAgDY;EACI,aAAA;AA9ChB;AAiDY;EACI,WAAA;AA/ChB;AAoDI;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAlDR;AAoDQ;EANJ;IAOQ,iBAAA;EAjDV;AACF;AAmDQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AAjDZ;AAmDY;EACI,wBAAA;AAjDhB;;AAuDA;EACI;IACI,SAAA;EApDN;AACF;AAuDA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AArDJ;AAuDI;EACI,aAAA;AArDR;;AAyDA;EAEI;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,iBAAA;IACA,oBAAA;IACA,4BAAA;IACA,+BAAA;IACA,UAAA;IACA,gBAAA;EAvDN;EAyDM;IACI,wBAAA;EAvDV;EA0DM;IACI,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EAxDV;EA2DM;IACI,eAAA;IACA,gBAAA;EAzDV;EA2DU;IACI,mBAAA;IACA,eAAA;EAzDd;EA6DM;IACI,gBAAA;IACA,WAAA;IACA,eAAA;IACA,wBAAA;EA3DV;EA6DU;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,gCAAA;EA3Dd;EA6Dc;IACI,aAAA;IACA,mBAAA;IACA,SAAA;EA3DlB;EA6DkB;IACI,WAAA;IACA,YAAA;EA3DtB;EA8DkB;IACI,eAAA;IACA,gBAAA;IACA,cAAA;EA5DtB;EAgEc;IACI,WAAA;IACA,YAAA;IACA,+BAAA;IACA,uBAAA;EA9DlB;EAkEU;IACI,aAAA;IACA,gBAAA;IACA,oCAAA;EAhEd;EAkEc;IACI,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,uBAAA;EAhElB;EAkEkB;IACI,WAAA;EAhEtB;EAiEsB;IACI,cAAA;IACA,qBAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;IACA,qBAAA;IACA,2BAAA;EA/D1B;EAiE0B;IACI,cAAA;EA/D9B;EAwEkB;IACI,yBAAA;EAtEtB;EA0Ec;IACI,iBAAA;EAxElB;AACF;AA8EA;EACI;IACI,aAAA;EA5EN;AACF;AA+EA,uCAAA;AACA,uCAAA;AACA,uCAAA;AAEA;EACI,0BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,6DAAA;EACA,wBAAA;EACA,gBAAA;AA9EJ;AAgFI;EACI,4BAAA;EACA,gBAAA;AA9ER;AAiFI;EACI,wBAAA;AA/ER;;AAmFA,qCAAA;AACA,qCAAA;AACA,qCAAA;AAEA,gDAAA;AACA,gDAAA;AACA,+CAAA;AACA,gDAAA;AAEA;EACI,iBAAA;AAlFJ;AAoFI;EAHJ;IAIO,4BAAA;EAjFL;AACF;;AAoFA,8CAAA;AACA,gDAAA;AACA,8CAAA","sourcesContent":["header {\n    width: 100%;\n    padding: 22px 0px;\n    background-color: #fff;\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;\n    transform: translateY(0);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;\n\n    &.header-hidden {\n        transform: translateY(-100%);\n        \n    }\n\n    &.header-visible {\n        transform: translateY(0);\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    .container {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        @media (min-width: 1200px) and (max-width: 1365px) {\n            padding: 0 20px;\n        }\n    }\n\n    .logo {\n        order: 1;\n        img {\n            max-height: 48px;\n            width: auto;\n        }\n    }\n\n    .mobile-menu-toggle {\n        display: none;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        padding: 0;\n        z-index: 10;\n        \n        img {\n            width: 30px;\n            height: 30px;\n            object-fit: contain;\n        }\n        \n        .close-icon {\n            display: none;\n        }\n        \n        &.active {\n            .menu-icon {\n                display: none;\n            }\n            \n            .close-icon {\n                display: block;\n            }\n        }\n    }\n\n    nav {\n        order: 2;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 1;\n        \n        ul {\n            display: flex;\n            list-style: none;\n            gap: 40px;\n            margin: 0;\n            padding: 0;\n        }\n\n        li {\n            position: relative;\n        }\n\n        a {\n            text-decoration: none;\n            color: #004481;\n            font-weight: 500;\n            padding: 10px 0;\n            transition: color 0.3s ease;\n            position: relative;\n            font-size: 16px;\n\n            &:hover {\n                color: #000;\n            }\n\n            &.active {\n                color: #004481;\n                border-bottom: 2px solid #004481;\n            }\n        }\n    }\n    \n    .header-icons {\n        order: 3;\n        display: flex;\n        align-items: center;\n        gap: 16px;\n        \n        \n        a {\n            display: block;\n            text-decoration: none;\n            display: none !important;\n\n            \n            img {\n                width: 18px;\n                height: 19px;\n                object-fit: contain;\n                vertical-align: middle;\n            }\n        }\n        \n        .search-btn {\n            display: none !important;\n            background: transparent;\n            border: none;\n            cursor: pointer;\n            padding: 0;\n            \n            img {\n                width: 18px;\n                height: 19px;\n                object-fit: contain;\n                vertical-align: middle;\n            }\n        }\n        \n        .lang-selector {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 3px;\n            text-decoration: none;\n            position: relative;\n            cursor: pointer;\n            \n            span {\n                font-weight: 400;\n                font-size: 15px;\n                color: #004481;\n                line-height: 1;\n            }\n            \n            .dropdown {\n                position: absolute;\n                top: 100%;\n                left: 0;\n                background: #fff;\n                z-index: 100;\n                box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n                border-radius: 4px;\n                min-width: 80px;\n                margin-top: 10px;\n                opacity: 0;\n                visibility: hidden;\n                transition: all 0.3s ease;\n                \n                ul {\n                    list-style: none;\n                    padding: 8px 0;\n                    margin: 0;\n                }\n                \n                li {\n                    padding: 0;\n                }\n                \n                a {\n                    padding: 8px 16px;\n                    display: block;\n                    color: #004481;\n                    font-weight: 200;\n                    font-size: 16px;\n                    \n                    &:hover {\n                        background: rgba(0,68,129,0.05);\n                    }\n                }\n            }\n            \n            &:hover .dropdown {\n                opacity: 1;\n                visibility: visible;\n            }\n        }\n    }\n\n    @media (max-width: 1200px) {\n        padding: 13px 20px;\n        \n        .container {\n            padding: 0;\n        }\n        \n        .logo {\n            img {\n                max-height: 56px;\n                height: 56px;\n                width: auto;\n            }\n        }\n        \n        .header-icons {\n            order: 2;\n            margin-left: auto;\n            margin-right: 20px;\n            display: flex;\n            align-items: center;\n            gap: 30px;\n            display: none !important;\n            \n            a img {\n                width: 24px;\n                height: 24px;\n            }\n            \n            .lang-selector {\n                display: none;\n            }\n        }\n        \n        .mobile-menu-toggle {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            order: 3;\n            \n            img {\n                width: 28px;\n                height: 28px;\n            }\n        }\n\n        nav {\n            position: fixed;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: calc(100vh - 80px);\n            margin-top: 80px;\n            background: #fff;\n            flex-direction: column;\n            justify-content: flex-start;\n            padding-top: 40px;\n            padding-bottom: 50px;\n            transform: translateX(-100%);\n            transition: transform 0.3s ease;\n            z-index: 8;\n            overflow-y: auto;\n\n            &.active {\n                transform: translateX(0);\n            }\n\n            ul {\n                flex-direction: column;\n                gap: 56px;\n                text-align: left;\n                align-items: flex-start;\n                width: 100%;\n                padding: 0 20px;\n            }\n\n            a {\n                font-size: 24px;\n                font-weight: 600;\n                \n                &.active {\n                    border-bottom: none;\n                    padding: 10px 0;\n                }\n            }\n        }\n\n        body.menu-open {\n            overflow: hidden;\n        }\n    }\n}\n\n.search-overlay {\n    position: fixed;\n    top: 90px;\n    left: 0;\n    width: 100%;\n    background: #fff;\n    border-bottom: 1px solid #eaeaea;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n    padding: 15px 0;\n    z-index: 9;\n    transform: translateY(-100%);\n    z-index: 99999999;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s ease;\n    \n    &.active {\n        transform: translateY(0);\n        opacity: 1;\n        visibility: visible;\n    }\n    \n    .container {\n        display: flex;\n        align-items: center;\n    }\n    \n    .search-form {\n        width: 100%;\n        position: relative;\n        \n        input {\n            width: 100%;\n            padding: 10px 32px;\n            border: none;\n            font-size: 16px;\n            color: #333;\n            background: transparent;\n\n            @media (max-width: 1200px) {\n                padding: 10px 0px;\n            }\n            \n            &:focus {\n                outline: none;\n            }\n            \n            &::placeholder {\n                color: #999;\n            }\n        }\n    }\n    \n    .close-search {\n        margin-right: 32px;\n        background: none;\n        border: none;\n        cursor: pointer;\n\n        @media (max-width: 1200px) {\n            margin-right: 0px;\n        }\n        \n        img {\n            width: 19px;\n            height: 19px;\n            object-fit: contain;\n            transition: transform 0.3s ease;\n\n            &:hover {\n                transform: rotate(90deg);\n            }\n        }\n    }\n}\n\n@media (max-width: 1200px) {\n    .search-overlay {\n        top: 75px;\n    }\n}\n\nbody.menu-open {\n    overflow: hidden;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n\n    header .header-icons > a:first-child {\n        display: none;\n    }\n}\n\n@media (max-width: 1199px) {\n\n    nav {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: calc(100vh - 80px);\n        margin-top: 80px;\n        background: #fff;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        padding-top: 40px;\n        padding-bottom: 50px;\n        transform: translateX(-100%);\n        transition: transform 0.3s ease;\n        z-index: 8;\n        overflow-y: auto;\n\n        &.active {\n            transform: translateX(0);\n        }\n\n        ul {\n            flex-direction: column;\n            gap: 56px;\n            text-align: left;\n            align-items: flex-start;\n            width: 100%;\n            padding: 0 20px;\n        }\n\n        a {\n            font-size: 24px;\n            font-weight: 600;\n            \n            &.active {\n                border-bottom: none;\n                padding: 10px 0;\n            }\n        }\n\n        .mobile-lang-accordion {\n            margin-top: auto;\n            width: 100%;\n            padding: 0 20px;\n            display: none !important;\n\n            .lang-accordion-toggle {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                width: 100%;\n                padding: 15px 0;\n                background: none;\n                border: none;\n                cursor: pointer;\n                text-align: left;\n                border-bottom: 1px solid #e0e0e0;\n\n                .lang-info {\n                    display: flex;\n                    align-items: center;\n                    gap: 10px;\n\n                    img {\n                        width: 18px;\n                        height: 18px;\n                    }\n\n                    span {\n                        font-size: 16px;\n                        font-weight: 600;\n                        color: #004481;\n                    }\n                }\n\n                .toggle-arrow {\n                    width: 16px;\n                    height: 16px;\n                    transition: transform 0.3s ease;\n                    transform: rotate(0deg);\n                }\n            }\n\n            .lang-accordion-content {\n                max-height: 0;\n                overflow: hidden;\n                transition: max-height 0.3s ease-out;\n\n                ul {\n                    padding: 10px 0 10px 0;\n                    margin: 0;\n                    list-style: none;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 20px;\n                    align-items: flex-start;\n\n                    li {\n                        width: 100%;\n                        a {\n                            display: block;\n                            padding: 10px 0 0 0px;\n                            font-size: 16px;\n                            font-weight: 500;\n                            color: #333;\n                            text-decoration: none;\n                            transition: color 0.2s ease;\n\n                            &:hover {\n                                color: #004481;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &.active {\n                .lang-accordion-toggle {\n                    .toggle-arrow {\n                        transform: rotate(180deg);\n                    }\n                }\n\n                .lang-accordion-content {\n                    max-height: 200px;\n                }\n            }\n        }\n    }\n}\n\n@media screen and (min-width: 1200px) {\n    .mobile-lang-accordion {\n        display: none;\n    }\n}\n\n/* ================================== */\n/* Smart Sticky Header Styles - START */\n/* ================================== */\n\nheader {\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1000;\n    transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;\n    transform: translateY(0);\n    box-shadow: none;\n\n    &.header-hidden {\n        transform: translateY(-100%);\n        box-shadow: none;\n    }\n\n    &.header-visible {\n        transform: translateY(0);\n    }\n}\n\n/* ================================ */\n/* Smart Sticky Header Styles - END */\n/* ================================ */\n\n/* =========================================== */\n/* Body Padding for Fixed Header - START       */\n/* Bu kod style.scss'in sonuna da eklenebilir */\n/* =========================================== */\n\nbody {\n    padding-top: 96px;\n\n    @media (max-width: 1199px) {\n       padding-top: 86px !important;\n    }\n}\n\n/* ========================================= */\n/* Body Padding for Fixed Header - END         */\n/* ========================================= */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
